<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">    
    <v-row>
      <v-col
        xs="12"
        md="6"
      >
        <v-select
          v-model="store"
          :items="$store.state.attending_stores.map(s => {
            return {text: s.name, value: s.uuid}
          })"          
          label="Produto da mensagem"
          required            
        ></v-select>
      </v-col>
      <v-col
        xs="12"
        md="6"
      >
        <v-select
          v-model="contact_status"
          :items="contactStatuses"
          label="Tipo de mensagem"
          no-data-text="Selecione um produto primeiro."
          required            
        ></v-select>
      </v-col>
      <v-col xs="12">
        <v-alert
          border="top"
          colored-border
          type="info"
          elevation="2"
        >
        <p>
        Você pode inserir informações sobre os pedidos diretamente nas mensagens de atendimento através das tags de mensagem.
        </p>
        <p>Quando a mensagem for enviada, as tags serão substituídas pelas informações reais do pedido, então lembre-se de deixar a mensagem suficientemente curta para poder ser enviada.
        </p>
        <p>As tags disponíveis atualmente são:</p>
        <v-chip @click="() => insertTag(b)" :key="i" v-for="(b, i) in tags">{{ b }}</v-chip>
        </v-alert>
        <v-textarea
          solo
          required
          @click="storeSelection"
          @focus="storeSelection"
          @blur="storeSelection"
          ref="messageRef"          
          :counter="255"
          v-model="message"
          name="message"
          label="Mensagem"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-btn
      :disabled="!valid"
      color="success"
      type="submit"
    >
      {{ this.selectedMessage ? 'Atualizar' : 'Cadastrar'}}
    </v-btn>
  </v-form>
</template>

<script>
export default {
  props: {
    selectedMessage: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  name: 'Form',
  created() {
    this.$store.dispatch('fetchAttendingStores');
  },
  computed: {
    contactStatuses() {
      if (!this.store) {
        return []
      }
      const store = this.$store.state.attending_stores
      .find(s => s.uuid === this.store);      
      if (store) {
        return store.contact_statuses.map(c => ({text: c.status, value: c.id}))
      }
      return [];
    }
  },
  methods: {
    storeSelection() {
      var tArea = this.$refs.messageRef.$el.querySelector('textarea');
      this.selectionStart = tArea.selectionStart;
      this.selectionEnd = tArea.selectionEnd
    },
    insertTag(tag) {
      tag = ` ${tag} `;      
      var tArea = this.$refs.messageRef.$el.querySelector('textarea');      
      if (0 == tag) {
        return;
      }
      if (0 == cursorPos) {
        return;
      }

      // get cursor's position:
      var startPos = this.selectionStart,
        endPos = this.selectionEnd,
        cursorPos = startPos,
        tmpStr = this.message;

      // insert:
      this.message = tmpStr.substring(0, startPos) + tag + tmpStr.substring(endPos, tmpStr.length);

      // move cursor:
      setTimeout(() => {
        cursorPos += tag.length;
        tArea.selectionStart = tArea.selectionEnd = cursorPos;
        tArea.focus();
      }, 10);
    },
    submit() {
      if (this.$refs.form.validate()) {
        const data = {
          message: this.message,
          contact_status_id: this.contact_status,
          store: this.store
        };
        if (this.selectedMessage) {
          data.id = this.selectedMessage.id;
          this.$emit('close');
        }
        this.$store.dispatch('createMessage', {data});
        this.$emit('close');
      }
    },
  },  
  data () {    
    return {
      store: this.selectedMessage ? this.selectedMessage.store.uuid : null,
      contact_status: this.selectedMessage ? this.selectedMessage.contact_status.id : null,
      message: this.selectedMessage ? this.selectedMessage.message : '',
      valid: false,
      tags: [
        '#primeiro_nome',
        '#nome_completo',
        '#email', 
        '#link_boleto', 
        '#codigo_boleto',
        '#link_rastreio'
      ],
      selectionStart: null,
      selectionEnd: null
    }
  }
}
</script>

<style lang="css" scoped>
</style>